<template>
    <v-container id="users-table-container">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
            :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
        //-->
        <v-data-table :headers="headers" show-expand :single-expand="true" :expanded.sync="expanded" :loading="loading" :height="$vuetify.breakpoint.xs ? 425 : '50vh'"
                      :items="filteredData"
                      item-key="hitnrun_usersId"
                      selectable-key="hitnrun_usersId"
                      :items-per-page="15"
                      :server-items-length="serverTotalCount"
                      :search="search_field"
                      class="elevation-1 backdrop"
                      @dblclick:row="(item, slot) => slot.expand(!slot.isExpanded)"
                      @update:options="optionsChanged"
                      :footer-props="{'items-per-page-options':[10, 20, 30, 50, -1], 'items-per-page-text' : 'Users per page:'}"
                      :no-data-text="`No Users Found`">

            <template v-slot:top>

                <v-row class="mobile-row">


                    <v-col cols="12" md="10" sm="10" class="header-col">
                        <v-text-field v-model="search_field" outlined
                                      label="Filter Using Keywords" single-line hide-details
                                      class="mx-4 py-md-4 newButton">

                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="2" sm="2" align-self="center" class="header-col">

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="secondary" v-bind="attrs" v-on="on"
                                       class="my-auto black--text newButton" @click="newUser">
                                    New
                                    <v-icon right
                                            dark>
                                        $plus
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Create A New User</span>
                        </v-tooltip>
                    </v-col>




                </v-row>

            </template>


            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="backdrop lighten-1">
                    <v-container class="expanded-item-container">

                        <v-row class="mx-md-4 mx-sm-2 expanded-item-row">

                            <v-col cols="12" sm="4" align-self="center" v-if="item.file_sig_image != ''">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-img class="mx-auto" content-class="sign-image" v-bind="attrs" v-on="on"
                                               max-height="100" height="150" contain eager
                                               max-width="200" wdith="150"
                                               :src="GenImageLink(item.file_sig_image)">

                                        </v-img>
                                    </template>
                                    <span>Signature Image</span>
                                </v-tooltip>

                            </v-col>

                            <v-col cols="12" sm="4" align-self="center" v-if="item.file_sig_image == '' && $vuetify.breakpoint.xs">
                                <div style="width: 300px;"></div>
                            </v-col>


                            <v-col cols="6" sm="2" align-self="center">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="secondary" v-bind="attrs" v-on="on" @click="editUser(item.hitnrun_usersId)">
                                            <v-icon color="black">$pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit User</span>
                                </v-tooltip>

                            </v-col>

                            <v-col cols="6" md="1" align-self="center">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="secondary" v-bind="attrs" v-on="on" @click="deleteUser(item.hitnrun_usersId)">
                                            <v-icon color="black">$del</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Delete User</span>
                                </v-tooltip>

                            </v-col>

                        </v-row>
                    </v-container>
                </td>
            </template>

            <template v-slot:header.case_num="{ header }">
                <button @click="test(`aa`)">{{ header.text}}</button>
            </template>
        </v-data-table>
    </v-container>
</template>

<style lang="scss" scoped>
    #users-table-container {
        padding: 0px;
        max-width: none !important;
    }

    .expanded-item-container {
    }



    @media only screen and (max-width: 600px) {
        .expanded-item-row {
            text-align: center;
        }

        .newButton {
            margin-left: 16px;
            width: 89%;
            margin-right: 16px;
        }

        .header-col {
            padding: 10px 0px !important;
        }

        .mobile-row {
            padding-top: 10px;
            text-align: -webkit-center;
            margin-bottom: 10px;
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        }
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "users-table",
        mixins: [bus_common],
        props: ["data", "serverTotalCount", "loading"],
        data() {
            return {
                expanded: [],
                search_field: "",
                headers: [
                    {
                        text: 'Name',
                        align: 'start',
                        value: 'proper_name',
                    },
                    { text: 'Email', value: 'email_user' },
                    { text: 'Title', value: 'title' },
                    { text: 'Phone', value: 'phone' }

                ],
            };
        },
        methods: {
            newUser() {
                this.$emit('newUser');
            },
            init() { },
            customSearch(value, search, item) {
                console.log(search, item)
                return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            optionsChanged(event) {
                this.$emit('optionsChanged', event)
            },
            editUser(hitnrun_usersId) {
                this.$emit('editUser', hitnrun_usersId)
            },
            deleteUser(hitnrun_usersId) {
                let callback = () => {
                    this.deleteUserCall(hitnrun_usersId);
                }
                this.swall_diag("Delete User?", "Are you sure you would like to delete the user? This will unassign the user for all their assignments.", "question", callback, "Yes", "No", null)
            },
            async deleteUserCall(hitnrun_usersId) {

                let form = { hitnrun_usersId: hitnrun_usersId }
                await this.$axios.post('api/hitnrunuser/deleteUser', form)
                    .then(response => {
                        this.$emit('refreshData');
                        this.swall_it("User Deleted!", "The user was successfully Deleted.", "success", null, null);

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });

            },
            GenImageLink(filename) {
                let link = window.location.origin + "/Upload/" + filename;
                return link
            },
        },
        computed: {
            filteredData: function () {
                return this.data.filter((item) => {
                    return Object.values(item).some(v => v && v.toString().toLowerCase().includes(this.search_field.toLowerCase()))
                });
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
